export const semver = /^([0-9]\d{0,4})\.([0-9]\d{0,4})\.([0-9]\d{0,4})$/;
